import { Http } from '@/core/classes/Http.class'

const BASE_URL = process.env.VUE_APP_BASE_URL as string
export const http = new Http(BASE_URL)
